/* eslint-disable */

// Custom queries for notifications
export const getUnreadNotificationsCount = /* GraphQL */ `
  query GetUnreadNotificationsCount($userID: ID!) {
    notificationsByUser(userID: $userID, filter: { status: { eq: UNREAD } }) {
      items {
        id
      }
    }
  }
`;

export const getNotificationsByUser = /* GraphQL */ `
  query GetNotificationsByUser(
    $userID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNOTIFICATIONFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notificationsByUser(
      userID: $userID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        status
        title
        message
        userID
        organizationID
        certificateID
        vendorID
        clientID
        metadata
        readAt
        archivedAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const markNotificationAsRead = /* GraphQL */ `
  mutation MarkNotificationAsRead($id: ID!, $readAt: AWSDateTime) {
    updateNOTIFICATION(
      input: {
        id: $id
        status: READ
        readAt: $readAt
      }
    ) {
      id
      status
      readAt
    }
  }
`;

export const markAllNotificationsAsRead = /* GraphQL */ `
  mutation MarkAllNotificationsAsRead($userID: ID!) {
    # This would need a custom resolver or batch operation
    # For now, we'll handle this client-side with multiple updates
  }
`;

export const archiveNotification = /* GraphQL */ `
  mutation ArchiveNotification($id: ID!, $archivedAt: AWSDateTime) {
    updateNOTIFICATION(
      input: {
        id: $id
        status: ARCHIVED
        archivedAt: $archivedAt
      }
    ) {
      id
      status
      archivedAt
    }
  }
`;

export const createNotificationForCertificateSubmission = /* GraphQL */ `
  mutation CreateNotificationForCertificateSubmission(
    $userID: ID!
    $organizationID: ID!
    $certificateID: ID!
    $vendorID: ID!
    $clientID: ID!
    $vendorName: String!
  ) {
    createNOTIFICATION(
      input: {
        type: CERTIFICATE_SUBMISSION
        status: UNREAD
        title: "New Certificate Submission"
        message: $vendorName
        userID: $userID
        organizationID: $organizationID
        certificateID: $certificateID
        vendorID: $vendorID
        clientID: $clientID
        metadata: "{}"
      }
    ) {
      id
      type
      status
      title
      message
      userID
      organizationID
      certificateID
      vendorID
      clientID
      createdAt
    }
  }
`;

export const createNotificationForCertificateExpiring = /* GraphQL */ `
  mutation CreateNotificationForCertificateExpiring(
    $userID: ID!
    $organizationID: ID!
    $certificateID: ID!
    $vendorID: ID!
    $clientID: ID!
    $vendorName: String!
    $metadata: AWSJSON
  ) {
    createNOTIFICATION(
      input: {
        type: CERTIFICATE_EXPIRING
        status: UNREAD
        title: "Certificate Expiring Soon"
        message: $vendorName
        userID: $userID
        organizationID: $organizationID
        certificateID: $certificateID
        vendorID: $vendorID
        clientID: $clientID
        metadata: $metadata
      }
    ) {
      id
      type
      status
      title
      message
      userID
      organizationID
      certificateID
      vendorID
      clientID
      metadata
      createdAt
    }
  }
`;

export const createNotificationForCommentMention = /* GraphQL */ `
  mutation CreateNotificationForCommentMention(
    $userID: ID!
    $organizationID: ID!
    $certificateID: ID!
    $vendorID: ID!
    $clientID: ID!
    $mentionedBy: String!
    $metadata: AWSJSON
  ) {
    createNOTIFICATION(
      input: {
        type: COMMENT_MENTION
        status: UNREAD
        title: "You were mentioned in a comment"
        message: $mentionedBy
        userID: $userID
        organizationID: $organizationID
        certificateID: $certificateID
        vendorID: $vendorID
        clientID: $clientID
        metadata: $metadata
      }
    ) {
      id
      type
      status
      title
      message
      userID
      organizationID
      certificateID
      vendorID
      clientID
      metadata
      createdAt
    }
  }
`;